export type MessageNotification = {
  messageId: string
  conversationId: string
  timestamp: number
}

let current: MessageNotification | null = null
const listeners = new Set<() => void>()

function emit() {
  for (const listener of listeners) listener()
}

/** Record the message that triggered the global chime. */
export function notifyIncomingMessage(messageId: string, conversationId: string) {
  current = { messageId, conversationId, timestamp: Date.now() }
  emit()
}

export function clearMessageNotification() {
  if (!current) return
  current = null
  emit()
}

export function getMessageNotification(): MessageNotification | null {
  return current
}

export function subscribeMessageNotification(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
